import { JobService } from './../../../services/job.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-clear',
  templateUrl: './job-clear.component.html',
  styleUrls: ['./job-clear.component.css']
})
export class JobClearComponent implements OnInit {

  constructor(public jobService:JobService) { }

  ngOnInit() {
  }

  job(){
    return this.jobService.currentJob;
  }

}
